<script setup>
import { computed } from 'vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import { useDateFnsLocale } from 'shared/composables/useDateFnsLocale';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt } = useMessageContext();

// Same reason as MessageMeta.vue: the month name is a word, and date-fns 2.x
// needs the locale on every call that renders one.
const { dateFnsLocale } = useDateFnsLocale();

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a', dateFnsLocale.value)
);
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span :title="content">{{ content }}</span>
  </BaseBubble>
</template>
